import { useCallback } from 'react';

export const useFocusRef = <T extends HTMLElement>() =>
  useCallback((node: T | null) => {
    if (node !== null) {
      // Delay focus to prevent scroll on Safari (https://stackoverflow.com/a/54192675)
      queueMicrotask(() => {
        node.focus({ preventScroll: true });
      });
    }
  }, []);
